export const defaultTemplates = [
  {
    id: 'default',
    name: 'Plantillas Predeterminadas',
    templates: [
      {
        id: 'reminder-7days',
        title: 'Recordatorio (7 días antes)',
        message: '¡Hola a todos! 👋\n\nQuiero recordarles que nuestra masterclass "{titulo}" se realizará en una semana, el {fecha} a las {hora}.\n\nReserva tu lugar y prepara tus preguntas. ¡Será una sesión llena de conocimiento valioso!\n\nTambién puedes unirte a nuestro grupo de WhatsApp: {enlace_whatsapp}\n\nSaludos cordiales.'
      },
      {
        id: 'reminder-3days',
        title: 'Recordatorio (3 días antes)',
        message: '¡Hola! 📆\n\nNuestra masterclass "{titulo}" se acerca rápidamente. Será este {fecha} a las {hora}.\n\nPrepara tu espacio de trabajo y asegúrate de tener una buena conexión a internet para aprovechar al máximo esta oportunidad de aprendizaje.\n\nÚnete a nuestro grupo de WhatsApp para estar al día: {enlace_whatsapp}\n\n¡Nos vemos pronto!'
      },
      {
        id: 'reminder-1day',
        title: 'Recordatorio (1 día antes)',
        message: '¡Atención! ⏰\n\n¡Mañana es el gran día de nuestra masterclass "{titulo}"!\n\nFecha: {fecha}\nHora: {hora}\n\nSi aún no te has unido a nuestro grupo de WhatsApp, este es el enlace: {enlace_whatsapp}\n\nNo olvides tener listos tus materiales y un espacio tranquilo para concentrarte. ¡Habrá tiempo para preguntas y respuestas!'
      },
      {
        id: 'reminder-same-day',
        title: 'Recordatorio (mismo día)',
        message: '¡Hoy es el día! 🚀\n\nNuestra masterclass "{titulo}" comienza en unas horas, a las {hora}.\n\nAquí tienes los datos para unirte:\n\nEnlace de Zoom: {enlace}\nID de reunión: {id_reunion}\nCódigo de acceso: {codigo_acceso}\n\nGrupo de WhatsApp: {enlace_whatsapp}\n\n¡Esperamos verte allí!'
      },
      {
        id: 'reminder-1hour',
        title: 'Recordatorio (1 hora antes)',
        message: '¡Última llamada! ⏱️\n\nLa masterclass "{titulo}" comienza en 1 hora.\n\nEnlace de Zoom: {enlace}\nID de reunión: {id_reunion}\nCódigo de acceso: {codigo_acceso}\n\nSi tienes problemas técnicos, únete a nuestro grupo de soporte en WhatsApp: {enlace_whatsapp}\n\nAsegúrate de tener todo listo para sacar el máximo provecho de esta sesión.'
      },
      {
        id: 'start',
        title: 'Inicio de la Masterclass',
        message: '¡Estamos comenzando ahora! 🎬\n\nLa masterclass "{titulo}" está iniciando en este momento.\n\nSi aún no te has unido, aquí están los datos:\n\nEnlace: {enlace}\nID de reunión: {id_reunion}\nCódigo de acceso: {codigo_acceso}\n\nSoporte en WhatsApp: {enlace_whatsapp}\n\n¡Te esperamos!'
      },
      {
        id: 'thanks',
        title: 'Agradecimiento post-Masterclass',
        message: '¡Muchas gracias por asistir! 🙏\n\nHa sido un placer compartir la masterclass "{titulo}" con todos ustedes.\n\nEn los próximos días recibirán el material complementario y la grabación de la sesión.\n\nSigue conectado con nosotros en el grupo de WhatsApp: {enlace_whatsapp}\n\n¡Espero que haya sido de gran valor para todos!'
      },
      {
        id: 'whatsapp-group',
        title: 'Invitación a grupo de WhatsApp',
        message: '✅ Clic al enlace para unirte al grupo de WhatsApp de este Masterclass.\n\n👉 {enlace_whatsapp}'
      }
    ]
  },
  {
    id: 'minimal',
    name: 'Plantillas Minimalistas',
    templates: [
      {
        id: 'min-reminder',
        title: 'Recordatorio previo',
        message: 'Masterclass: "{titulo}"\nFecha: {fecha}\nHora: {hora}\nEnlace: {enlace}\nID: {id_reunion}\nCódigo: {codigo_acceso}\nWhatsApp: {enlace_whatsapp}\n\nNos vemos pronto.'
      },
      {
        id: 'min-start',
        title: 'Inicio',
        message: 'Comenzando ahora: "{titulo}"\nEnlace: {enlace}\nID: {id_reunion}\nCódigo: {codigo_acceso}\nSoporte WhatsApp: {enlace_whatsapp}'
      },
      {
        id: 'min-thanks',
        title: 'Agradecimiento',
        message: 'Gracias por asistir a "{titulo}". Pronto recibirás la grabación. Comunidad: {enlace_whatsapp}'
      },
      {
        id: 'min-whatsapp',
        title: 'Solo WhatsApp',
        message: 'Grupo de WhatsApp para "{titulo}": {enlace_whatsapp}'
      }
    ]
  }
];
